import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowForwardFull = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.333496 11.0004C0.333496 10.4648 0.759621 10.0307 1.28527 10.0307L19.641 10.0307C20.1666 10.0307 20.5927 10.4648 20.5927 11.0004C20.5927 11.5359 20.1666 11.9701 19.641 11.9701L1.28527 11.9701C0.759621 11.9701 0.333496 11.5359 0.333496 11.0004Z",
		fill: "#3F3F3F"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.1298 21.3827C9.75815 21.004 9.75815 20.39 10.1298 20.0113L18.9746 11L10.1298 1.98873C9.75815 1.61004 9.75815 0.996063 10.1298 0.617374C10.5015 0.238684 11.1042 0.238684 11.4759 0.617374L21.3229 10.6498C21.5138 10.8443 21.5138 11.1558 21.3229 11.3503L11.4759 21.3827C11.1042 21.7614 10.5015 21.7614 10.1298 21.3827Z",
		fill: "#3F3F3F"
	})]
});
export default SvgArrowForwardFull;
